<template>
    <div id="rte">
        <screen ref='screen'></screen>
    </div>
</template>

<script>

import Screen from 'views/cdu/cduHeader/Screen'
import {initRte} from 'utils/initPageData'

export default { 
    name: 'Rte',
    components: {
        Screen
    },
    data() {
        return {
            showData: [],
            index: [],
            page1: [
                [
                    ['RTE',['','','']],
                    [1,2]
                ], 
                [
                    [ 'ORIGIN', 'DEST' ], 
                    [ '−−−−−', '□□□□' ] 
                ], 
                [ 
                    [ 'CO ROUTE', 'FLT NO.' ], 
                    [ '−−−−−', '−−−−−−−−' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '−−−−−−−−−−−−−−−−−−−−', '−−−−−−−−−−−−−−−−−−−−' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
            ],
            page2: [
                [
                    ['RTE',['','','']],
                    [2,2]
                ], 
                [
                    [ 'VIA', 'TO' ], 
                    [ '−−−−−', '−−−−−' ] 
                ], 
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '−−−−−−−−−−−−−−−−−−−−', '−−−−−−−−−−−−−−−−−−−−', ], 
                    [ '', '' ] 
                ],
            ]
        }
    },
    methods: {
        initPage(){
            this.index = this.page1[0][1]
            this.showData = this['page'+ this.index[0]]
        },
        chgPage(){
            this.showData = this['page'+ this.index[0]]
        }
    },
    created() {
        this.initPage()
        initRte(this)
    },
    watch: {
        'index': {
            handler(newV,oldV){
                initRte(this)
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style scoped>

</style>